import Link from "next/link";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

import { BaseButton } from "@/src/component/base/BaseButton";
import { DialogWithExit } from "@/src/component/base/DialogWithExit";
import { Dropdown } from "@/src/component/base/Dropdown";
import { GROWTHBOOK_URL } from "@/src/const";

import styles from "./ExperimentDialog.module.scss";
import theme from "@/styles/scss/theme.module.scss";

interface ExperimentDialogProps {
  open: boolean;
  onClose: () => void;
  save: () => void;
}

function ExperimentDialog({ open, onClose, save }: ExperimentDialogProps) {
  function openGrowthbook() {
    window.open(`${GROWTHBOOK_URL}/experiments`, "_growthbook");
  }

  return (
    <DialogWithExit
      dialogProps={{
        open,
        onClose,
      }}
      onExit={onClose}
    >
      <div className={styles.dialog}>
        <div className={styles.inner}>
          <div
            className={styles.dialogExit}
            onClick={onClose}
          >
            <CloseIcon
              fontSize="large"
              sx={{ color: theme.primaryMain }}
            />
          </div>
          <div className={styles.content}>
            <Typography variant="h2">Update Variants To Experiment</Typography>
            <Card variant="outlined">
              <CardContent className={styles.cardContent}>
                <Typography variant="body1">
                  Be sure to create an experiment in{" "}
                  <Link
                    href="https://growthbook.flow.life"
                    target="_blank"
                    onClick={openGrowthbook}
                  >
                    Growthbook
                  </Link>{" "}
                  before assigning variants
                </Typography>
              </CardContent>
            </Card>
            <Dropdown
              options={[
                {
                  label: "Experiment 1",
                  value: "experiment-1",
                },
                {
                  label: "Experiment 2",
                  value: "experiment-2",
                },
              ]}
              value="experiment-1"
              onChange={() => {}}
              id="experiment-dropdown"
              label="Experiment"
              placeholder="Select an experiment"
            />
            <BaseButton
              variant="contained"
              color="primary"
              fullWidth
              onClick={save}
            >
              Save Experiment
            </BaseButton>
          </div>
        </div>
      </div>
    </DialogWithExit>
  );
}

export default ExperimentDialog;
